export default "__VITE_ASSET__DLSzVioG__"